import { getStore } from '@core/store';

// Mapping service ID vers le nom de champ de limite
const SERVICE_FIELD_MAPPING = {
  '1xbet': 'Xbet',
  '1win': 'OneWin',
  'betwinner': 'Betwinner',
  'melbet': 'Melbet',
  'eightstarz': 'EightStarz',
  'pm': 'Pm',
  'usdt': 'Usdt'
};

// Mapping opération vers prefix de champ
const OPERATION_FIELD_MAPPING = {
  fund: 'deposit',
  withdraw: 'withdraw',
  buy: 'buy',
  sell: 'sell'
};

function getLimitField(operation, serviceId) {
  const operationPrefix = OPERATION_FIELD_MAPPING[operation];
  const serviceSuffix = SERVICE_FIELD_MAPPING[serviceId.toLowerCase()];
  return serviceSuffix ? `${operationPrefix}${serviceSuffix}` : null;
}

export function getMinAmount(countryCode, operation, serviceId = null) {
  const appDataStore = getStore('appData');
  const limits = appDataStore?.state?.data?.amountLimits?.[countryCode]?.minAmounts;

  if (!limits) return 1000;

  if (serviceId) {
    const field = getLimitField(operation, serviceId);
    if (field && limits[field]) return limits[field];
  }

  return limits.forTransaction || 1000;
}

export function getMaxAmount(countryCode, operation, serviceId = null) {
  const appDataStore = getStore('appData');
  const limits =
    appDataStore?.state?.data?.amountLimits?.[countryCode]?.maxAmounts;

  if (!limits) return Infinity;

  if (serviceId) {
    const field = getLimitField(operation, serviceId);
    if (field && limits[field] > 0) return limits[field];
  }

  return limits.forTransaction && limits.forTransaction > 0
    ? limits.forTransaction
    : Infinity;
}

export function getDailyLimit(countryCode, operation, serviceId = null) {
  const appDataStore = getStore('appData');
  const limits = appDataStore?.state?.data?.amountLimits?.[countryCode]?.dailyLimits;

  if (!limits) return Infinity;

  if (serviceId) {
    const field = getLimitField(operation, serviceId);
    if (field && limits[field] > 0) return limits[field];
  }

  return limits.forTransaction && limits.forTransaction > 0
    ? limits.forTransaction
    : Infinity;
}

export function getMonthlyLimit(countryCode, operation, serviceId = null) {
  const appDataStore = getStore('appData');
  const limits = appDataStore?.state?.data?.amountLimits?.[countryCode]?.monthlyLimits;

  if (!limits) return Infinity;

  if (serviceId) {
    const field = getLimitField(operation, serviceId);
    if (field && limits[field] > 0) return limits[field];
  }

  return limits.forTransaction && limits.forTransaction > 0
    ? limits.forTransaction
    : Infinity;
}

// Helper combiné pour toutes les limites d'une opération
export function getAmountLimits(countryCode, operation, serviceId = null) {
  return {
    min: getMinAmount(countryCode, operation, serviceId),
    max: getMaxAmount(countryCode, operation, serviceId),
    daily: getDailyLimit(countryCode, operation, serviceId),
    monthly: getMonthlyLimit(countryCode, operation, serviceId)
  };
}

// Helper pour obtenir le max effectif (minimum entre daily et monthly)
export function getEffectiveMaxLimit(countryCode, operation, serviceId = null) {
  const max = getMaxAmount(countryCode, operation, serviceId);
  const daily = getDailyLimit(countryCode, operation, serviceId);
  const monthly = getMonthlyLimit(countryCode, operation, serviceId);

  return Math.min(max, daily, monthly);
}
